module.exports = __webpack_public_path__ + "media/images/countryrect/dk-95f25b6428337a5d0fc4b9458c3b8ff3.svg";